import { useTranslation } from 'react-i18next';
import { usesGarmin } from '../lib/garmin.ts';

/**
 * "Garmin Edge 840" under a Garmin ride's title (Garmin brand guidelines:
 * directly beneath the title, never hidden). Renders nothing for rides
 * from other sources (``attribution`` is null).
 */
export function RideAttribution({
  text,
  className = '',
}: Readonly<{ text: string | null | undefined; className?: string }>) {
  if (!text) return null;
  return (
    <span
      data-testid="garmin-attribution"
      className={`text-xs font-medium text-(--color-text-secondary) ${className}`}
    >
      {text}
    </span>
  );
}

/** "Insights derived in part from Garmin device-sourced data." under an
 *  AI answer or analysis whose ``ai_sources`` include Garmin. */
export function GarminAiAttribution({
  sources,
  className = '',
}: Readonly<{ sources: readonly string[] | null | undefined; className?: string }>) {
  const { t } = useTranslation();
  if (!usesGarmin(sources)) return null;
  return (
    <p data-testid="garmin-ai-attribution" className={`text-[11px] text-(--color-text-secondary) ${className}`}>
      {t('garmin.aiAttribution')}
    </p>
  );
}
